module.exports = __webpack_public_path__ + "img/home_banner10.728d4973.png";